import React, { Component } from 'react';

require('./navbar.css');
require('firebase/firestore');

var firebase = require('firebase');
var db = firebase.firestore();

class Navigationbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            signedIn: false,
            uid: '',
            username: '',
            display: ''
        };
        this.signOut = this.signOut.bind(this);
    }

    signOut() {
        //Sign out the user
        firebase.auth().signOut().then(function () {
            // Sign-out successful.
            window.location.replace('/');
        }).catch(function (error) {
            // An error happened.
            console.error("There was an alert signing you out, please try again!");
        });
    }

    componentWillMount() {
        //Only display navigation bar if not on client site
        if (document.URL.includes("clients")) {
            console.log(document.URL);
            this.setState({
                display: 'none',
            });
        }
        //Check if the user is signed in, if so display the log out button 
        var referThis = this;
        //Check if the user has already logged in, if so lead to their profile page. if not, set the check status to False.  
        firebase.auth().onAuthStateChanged(function (user) {
            //user has been signed in 
            if (user) {
                var docRef = db.collection("users").doc(user.email.toString());
                docRef.get().then(doc => {
                    if (doc && doc.exists) {
                        //The user exists, so get this username. 
                        referThis.setState({
                            username: doc.data().username,
                            signedIn: true
                        });
                    }
                }).catch(function (err) {
                    //There was an error getting user's information 
                    return (
                        <h1>There was an error getting your information, please try again later!</h1>
                    );
                });
            } else {
                referThis.setState({
                    signedIn: false
                })
            }
        }, function (error) {
            referThis.setState({
                signedIn: false
            });
        });
    }


    render() {
        return (
            <nav className="navbar navbar-expand-lg sticky-top" id='navbar' style={{ display: this.state.display }}>
                <a className="navbar-brand" href="/">
                    <img src='https://firebasestorage.googleapis.com/v0/b/tinqertinquer.appspot.com/o/Tinqer_logo_transparent.png?alt=media&token=b4d95f8e-eda9-4ae4-bf3a-caeef2a9ea74'
                        id="navbar_logo" className="d-inline-block align-top" alt="Tinqer_logo" />
                </a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#myNavBar" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <i className="fas fa-chevron-circle-down" id="navbar_toggler"></i>
                </button>
                <div className="collapse navbar-collapse" id="myNavBar">
                    <ul className="navbar-nav mr-auto text-center" >
                        <li className="nav-item">
                            <a href="/#AboutSection" id="nav_link" className="nav-link">
                                <b>About Us</b></a>
                        </li>
                        <li className="nav-item">
                            <a href="/#keyFeatureSection" id="nav_link" className="nav-link">
                                <b>Features</b></a>
                        </li>
                        <li className="nav-item">
                            <a href="/#contactUsForm" id="nav_link" className="nav-link">
                                <b>Pricing</b></a>
                        </li>
                        <li className="nav-item">
                            <a href="/catalog" id="nav_link" className="nav-link">
                                <b>AI Solutions</b></a>
                        </li>
                        <li className="dropdown nav-item text-center">
                            <a className="nav-link dropdown-toggle" href="#" id="nav_link" role="button" data-toggle="dropdown" > More
                            </a>
                            <div className="dropdown-menu moreDropdownMenu">
                                <a className="dropdown-item" id="more_dropdown" href="/AddBot">
                                    {
                                        this.state.signedIn ? "Add Bot" : "Developers"
                                    }
                                </a>
                                <a className="dropdown-item" id="more_dropdown" href="/AutomationServices">Other Services</a>
                                <a style={{ display: this.state.signedIn ? 'none' : 'block' }}
                                    className="dropdown-item" id="more_dropdown" href="/signin">Sign In</a>
                                <a style={{ display: this.state.signedIn ? 'block' : 'none' }}
                                    className="dropdown-item" id="more_dropdown" href={`/developers/${this.state.username}`}>
                                    Profile
                                </a>
                                <button style={{ display: this.state.signedIn ? 'block' : 'none' }}
                                    type='button' className="dropdown-item" id="more_dropdown" onClick={() => this.signOut()}>
                                    Sign Out
                                </button>
                            </div>
                        </li>
                    </ul>
                    { /* <form className="form-inline my-2 my-lg-0" id="search_box">
                            <input className="form-control mr-sm-2" type="search" placeholder="Search..." aria-label="Search" />
                            <button className="btn btn-outline-info my-2 my-sm-0" type="submit">Search</button>
                        </form> */
                    }

                </div>
            </nav >
        );
    }
}

export default Navigationbar;


// WEBPACK FOOTER //
// ./src/Navigation/Navigationbar.js